import request from './request';
import { limit, toSearchQuery, merge } from './helpers';

export default {
  find: (filter, page, pageSize = 10) =>
    request.get(
      `/graphic-asset?${merge(limit(pageSize, page), toSearchQuery(filter))}`
    )
};
